import { IAppState } from '../../redux';

export function selectMinimalBet(state: IAppState): number {
  const {
    auction: { minimalBet },
  } = state;

  return minimalBet;
}
